exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".impersonate-bar[data-v-196b47c0]{background-color:#333;background-image:url(\"/images/stripe.svg\");background-size:25px;background-repeat:repeat-x;background-position:0 100%}.impersonate-bar a[data-v-196b47c0]{padding:1em 0;font-size:.775em;display:block;color:#f5f5f5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-196b47c0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Elements/ImpersonateBar.vue
// module id = u3Dk
// module chunks = 0